import { Application } from "@hotwired/stimulus";
import FilesLimitController from "../src/decidim/questionnaires/controllers/files_limit_controller";
import MandatoryQuestionsController from "../src/decidim/questionnaires/controllers/mandatory_questions_controller";
import ResponseConfirmationController from "../src/decidim/questionnaires/controllers/response_confirmation_controller";
import "../stylesheets/decidim/questionnaires/confirm_attachments.scss";
import "../stylesheets/decidim/questionnaires/files_limit.scss";
import "../stylesheets/decidim/questionnaires/mandatory_questions.scss";
import "../stylesheets/decidim/questionnaires/responses_counter.scss";
import "../stylesheets/decidim/questionnaires/step_counter.scss";
const application = window.Stimulus || Application.start();
application.register("files-limit", FilesLimitController);
application.register("mandatory-questions", MandatoryQuestionsController);
application.register("response-confirmation", ResponseConfirmationController);
